'use client'

import { useEffect, useState } from 'react'

// Installed (home-screen) copies keep running old JS after a new service worker takes
// over. When that happens, reload if the app is in the background, otherwise offer a
// refresh. Also re-check for a new version whenever the app returns to the foreground.
export default function ServiceWorkerUpdatePrompt() {
  const [updateReady, setUpdateReady] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return

    // A first-ever install also fires controllerchange; only react to replacements.
    let hadController = !!navigator.serviceWorker.controller
    let reloading = false

    const onControllerChange = () => {
      if (!hadController) {
        hadController = true
        return
      }
      if (reloading) return
      if (document.visibilityState === 'hidden') {
        reloading = true
        window.location.reload()
      } else {
        setUpdateReady(true)
      }
    }

    const checkForUpdate = () => {
      if (document.visibilityState === 'visible') {
        navigator.serviceWorker.getRegistration().then(reg => reg?.update()).catch(() => {})
      }
    }

    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange)
    document.addEventListener('visibilitychange', checkForUpdate)
    return () => {
      navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange)
      document.removeEventListener('visibilitychange', checkForUpdate)
    }
  }, [])

  if (!updateReady) return null

  return (
    <div className="fixed bottom-4 left-1/2 z-[100] flex -translate-x-1/2 items-center gap-3 rounded-full bg-[#202020] px-4 py-2.5 text-sm text-white shadow-lg">
      <span>A new version is available.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-full bg-[#85C349] px-3 py-1 font-semibold text-white hover:bg-[#75b339]"
      >
        Refresh
      </button>
    </div>
  )
}
